// extracted by mini-css-extract-plugin
module.exports = {"container":"sign_up_confirm_phone-module__container--345F5"};